import React, { useState } from 'react';
import { injectIntl } from 'react-intl';

import Input from './Input';
import { validateEmail } from '../../lib/ep';
import { useThrottle } from '../../lib/hooks';

const EmailField = (props) => {
	const [ is_valid, setIsValid ] = useState(true);

	const validateFormat = (value) => {
		const is_valid = validateEmail(value);
		if(props.passed != undefined) props.passed(is_valid);
		if(props.onValidate != undefined)props.onValidate(is_valid, props.name, "Invalid email format");
		setIsValid(is_valid);
	};

	const onChangeDebounced = useThrottle(validateFormat, 200);

	const change = (k, v) => {
		let email = "";
		for(let i = 0; i < v.length; i++) {
			email += (v.charAt(i) != " ") ? v.charAt(i) : "";
		}
		if(props.change) props.change(k, email);
		onChangeDebounced(email);
	};

	const newp = { ...props, change };
	if(newp.errors == undefined) newp.errors = {};
	if(newp._type == undefined) newp._type = 'email';

	const _field_styles = newp?._field_style ?? {};
	const mail_err  = newp.errors['email'];

	if(newp.placeholder == undefined) newp.placeholder = props.intl.formatMessage({id:"me@your-domain.com"});

	if(!is_valid && newp.errors[props.name] == undefined && newp.passed == undefined) {
		newp.errors[props.name] = "Invalid email format";
	}
	if(mail_err != undefined) newp.errors[props.name] = mail_err;

	if(is_valid && props.errors != undefined && props.errors[props.name] == undefined) newp.errors = {};

	if(newp.passed != undefined) {
		newp.onBlur = () => newp.passed(is_valid);
	}

	const classes = ['react_field', 'gui_email_input'];
	if(newp._field_class != undefined) {
		classes.push(newp._field_class);
	}

	return (
		<div class={classes.join(" ")} style={_field_styles}>
			<div class="field_container this_input">
				<Input {...newp} />
			</div>
		</div>
	);
	
}

export default injectIntl(EmailField);